import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { AuthenticationService } from '../authentication.service';
import { Global } from '../classes/Global';
import { StorageHelper } from '../helpers/StorageHelper';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { BaseService } from '../classes/BaseService';
import { Log } from '../helpers/Log';

declare var jsSHA: any;

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [ AuthenticationService ]
})
export class ChangePasswordComponent extends BaseComponent implements OnInit {

  shaObj: any;
  password: string = "";
  confirmPassword: string = "";

  invalidPassword: boolean = false;
  emailChangeSuccess: boolean = false;
  passwordChangeSuccess: boolean = false;
  serverError: boolean = false;
  serverMessage: string = "";

  @Output() onAuthFail = new EventEmitter();
  @Output() close = new EventEmitter();

  constructor(private authenticationService: AuthenticationService) {
    super();
  }

  ngOnInit() {
  }

  onPasswordChange(password) {
    this.password = password;
  }

  onConfirmPasswordChange(password) {
    this.confirmPassword = password;
  }

  hashPassword(): string {
    this.shaObj = new jsSHA("SHA-256", "TEXT");
    this.shaObj.update(this.password);
    return this.shaObj.getHash("HEX");
  }

  changePassword() {

    if(!ValidationHelper.isValidString(this.password) || !ValidationHelper.isValidString(this.confirmPassword) ||
    this.password != this.confirmPassword) {
      this.invalidPassword = true;
      return;
    }

    this.invalidPassword = false;

    this.authenticationService.changePassword(Global.getCountry(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), this.hashPassword()).subscribe(res => {

      if(res && res["message"] == BaseService.COULDNT_LOAD_USER) {
        Global.clearSaveUserInfos();
        this.onAuthFail.emit();
      }
      else if(res && res["status"] == "success"){
        this.passwordChangeSuccess = true;
      }

    }, err => {
      Log.getInstance().d(err);
    });
  }

}
